import MaterialTableBody, { TableBodyProps } from '@mui/material/TableBody';

export function TableBody(props: TableBodyProps) {
    return <MaterialTableBody data-testid={'TableBody-container'} {...props} />;
}

export default TableBody;
